module.exports = __webpack_public_path__ + "static/media/anim2.910c4928.png";